
import React from 'react';
import axios2 from 'services/axios2';

import {useParams} from 'react-router-dom';
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { NuDropdown } from 'components/nubox/NuDropdown';

import { withRouterJim } from "router/withRouterJim";
import NuConfirm from "components/nubox/Box/NuConfirm";


import user from 'assets/img/user.jpg';

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
} from 'reactstrap';
import NuListSearch from 'components/nubox/NuListSearch';


const data = [
  //{ id_medico: 1,  nombre: 'ALEX LIZARRAGA',  especialidad: '00000023',tel:''}, 
];
const data1 = [
  { value: 1, label: "Apple" },
  { value: 2, label: "Facebook" },
];
/*$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$*/
class Inscripcion extends React.Component {  

  
  
  state = {
    modalInsertar: false,
    
        
    form: {
      name: 0,
    },
    data: data,/* lista de datos */

    carreras_arr: [],
    item_selected:{},
    
  };
  //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
    //this.modalRef = React.createRef();//create ref
  }
  //------------------
  //------------------------------------------------------
  componentDidMount() {
    //--limpiamos el array de datos
    this.setState({data:[]});
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };
  //------------
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }
  //------------------------
  get_carreras = (key='') => {
    console.log("get_carreras")
    let param = { 
      key1: key
    }
    console.log(param);
    axios2.post( 'inscripcion_get_carreras', param)
    .then(res => {
    
        if(res.data.length>0){ 
            this.setState({carreras_arr: res.data});
        }else{
            NotificationManager.error('No existen datos');
        }

    }).catch(error => {
        alert('---- Existio un error ---');
        console.log(error);
        
    });
  };
  //------------------------------
  // item es {value,label}
  onClickItemList =( item ) =>{
    console.log("onClickItemList")
    console.log(item)
    //---------cargamos el detalle en la otra tabla
    //---establecemos como item_selected
    this.setState({ item_selected: item});

    //-----------cargamos la tabla
    this.cargar_data(item.value)  //en este caso el id_u del docente
  }
  //------------------------
  onClickItemBtn =( key ) =>{
    console.log("onClickItemBtn")
    console.log(key)
    //---------cargamos el detalle en la otra tabla
    this.get_carreras(key)  //en este caso el id_u del docente
    
  }
  //====================================================== 
  // item tiene value, label
  cargar_data = (id_carre) => {
    let param = { 
      id_carre: id_carre
    }
    console.log(param);
    axios2.post( 'inscripcion_get_list', param)
    .then(res => {
    
        if(res.data.length>0){ 
            this.setState({data: res.data});
            //---establecer como inicial
            this.setState({ item_selected: res.data[0] });
        }else{
            NotificationManager.error('No existen datos');
        }

    }).catch(error => {
        alert('---- Existio un error ---');
        console.log(error);
        
    });

    //---establecemos como item_selected
    //this.setState({ item_selected: item});
  };
  //======================================================     
  imprimirBoleta =(id_inscrip)=>{
    let fileURL = process.env.REACT_APP_API_URL  + 'inscripcion_pdf/'+ id_inscrip;
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
  }
  /* === This is where the magic happens ==== */
  /*handleSubmit = event => {
    event.preventDefault();
    this.cargar_data();
  }*/
  //-----------------------------------------------------------------

  //-----------------------------------------------------------------
 
  //-----------------------------------------------------------------
  eliminar = (item) =>{
    console.log('eliminar');
    
    this.refNuConfirm.current.show({
      message: 'Esta seguro de eliminar?',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        let idd = item.id_doc_mat;
        //this.modalRef.current.eliminar(idd);
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })

  }
  //-------------------------------------
  okModal =()=>{
    console.log('citaOkModal');
    this.cargar_data(this.state.item_selected.value);
  }
  //-------------------------------------
  closeModal =()=>{
    console.log('citaCancelModal');
  }
  //------------------------------------
  //-------------------------------------
  render() {
  
    return (
      <div>
      
        { 
        
          //JSON.stringify( this.state )
        }
        <div className='content'>

          {/*{/*--- -----------------------------*/}
          <div className='row'>
            <div className='col-md-12'>
              <h3> Inscripcion de estudiantes Nuevos</h3>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-3'>
              <NuListSearch
                titulo='Carreras'
                value={ this.state.item_selected.value}
                options={this.state.carreras_arr}
                placeholder=''
                onClickBtn={ this.onClickItemBtn }
                onClickItem={ this.onClickItemList }
              />
            </div>
            {/** */}
            <div className='col-md-9'>
              <div className='top_title2'>
                <div className='row'>
                  <div className='col-md-12'>
                    
                  
                    <div className=' pull-right'>
                      {/*
                      <Button onClick={() => this.nuevo()} 
                        className='create-modal btn btn-info ' >
                        <i className='fa fa-plus'></i> Nuevo 
                      </Button>
                      */}
                    </div>
                    <h4>Carrera: { this.state.item_selected.label }</h4>
                  </div>
                </div>
              </div>

              <table className='table table-striped table-hover' width='100%' align='center'>
                <thead>
                  <tr>
                    <th>id_preins</th>
                    <th>Nombre</th>
                    <th>C.I.</th>
                    <th>Carrera</th>
                    <th>Accion</th>
                  </tr>

                </thead>
                <tbody>
                  {/* className='text-left' */}
                  
                  {this.state.data.map((item, index) => (
                    <tr key={index}> 
                      <td>{ item.id_inscrip }</td>
                      <td>{ item.nomape_tmp }</td>
                      <td>{ item.nro_doc }</td>
                      <td>{ item.nombreca }</td>

                      <td>
                        <Button className='btn btn-warning btn-sm' title='Habilitar' 
                          onClick={() => this.imprimirBoleta(item.id_inscrip)}>
                          <i className='fa fa-edit'></i> Imprimir Boleta
                        </Button>
                      </td>
                    </tr>
                  ))}



                </tbody>
              </table> 
            </div>
            {/** */}
            
          </div>


        
          
          {/*-- */}
          <div className="row">
             
          </div>
          {/*-- */}

          

        </div>
        
        <ToastContainer />
        <NuConfirm   ref={ this.refNuConfirm }    />
      </div>
      
    );
  }
}
//------------para que soporte la funcionalidad de parametros

export default withRouterJim (Inscripcion);